var React = require('react');

function RestaurantInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"className":"f0","d":"M23 19l-3.3-3.2c-.5-.5-.7-1.2-.7-1.8v-2c0-5 3.2-9.5 3.2-9.5l.8.5v16z","key":0}),React.createElement("circle",{"className":"f0","cx":"23","cy":"3","r":"1","key":1}),React.createElement("path",{"className":"f0","d":"M24 3h-2l-1 10v13.5c0 .8.7 1.5 1.5 1.5s1.5-.7 1.5-1.5V3zM13 2.4a.5.5 0 00-1 .1v5.9a.6.6 0 01-1.3 0l-.6-6c0-.2-.3-.4-.6-.4s-.5.2-.6.5l-.6 6A.6.6 0 017 8.3V2.5a.5.5 0 00-1 0C5.6 3.6 5 7.3 5 9c0 4 3 5 3 5v12.5a1.5 1.5 0 003 0V14s3-1 3-5c0-1.6-.7-5.3-1-6.6z","key":2})]);
}

RestaurantInline.defaultProps = {"viewBox":"0 0 30 30"};

module.exports = RestaurantInline;

RestaurantInline.default = RestaurantInline;
